export default __webpack_public_path__ + "static/media/calendar-v2.ab6f11e2.svg";